import {useTranslation} from 'react-i18next';
import {getRegExpFromString, GUEST_FORM_NAMES, isRequiredFormField} from '@chekin/core';
import {AddFormType} from 'context/guest';
import {type FormFieldsMapper} from './types';

type Props = {
  formFieldsMapper: FormFieldsMapper;
  fieldName: GUEST_FORM_NAMES;
  formFields: AddFormType;
};
export const DefaultField = ({formFieldsMapper, fieldName, formFields}: Props) => {
  const {t} = useTranslation();
  const format = getRegExpFromString(formFields?.[fieldName]?.format || '');
  const required = isRequiredFormField(formFields?.[fieldName])
    ? t('this_field_is_required')
    : false;

  return formFieldsMapper[fieldName]?.({required, format});
};
